import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export const GetBuyerNdaTermPreferences = createAsyncThunk(
    'marketplaceBuyers/getBuyerNdaTermPreferences',
    async (buyerId: number | null, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceBuyerProfiles/${buyerId}/NdaPreferences`
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch profile at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch profile');
            }

            return {
                ndaTermPreferences: response.data,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching profile.',
                'error'
            );
            throw error;
        }
    }
);
